import axios from 'axios';

import { charsheetAPI, TABLE_CHARS, DEFAULT_CAMPAIGN } from '../../../globals.js';
import { sanitizeCharName } from '../../../helpers/sanitizeInput.js';

async function SAVE_CHAR(postData, characterName = "Jack Squat", campaign = DEFAULT_CAMPAIGN, setChar = '', version="0.5") {

    // save the character data in postData to dynamoDB

    console.log({ SaveChar: { name: characterName, campaign: campaign, version: version, chardata: postData } });

    const charsheetTable = TABLE_CHARS

    // confirm the name to save as
    // replace prompt with a 'drop-down' window

    var saveName = prompt("Save name:  ** CAUTION - ALL SAVES PERMANENT **", characterName);

    if (saveName === null || saveName === "") {
        const txt = "User cancelled the prompt.";
        console.log(txt);
        return 'User Cancelled'; }

    saveName = sanitizeCharName(saveName);
    if (!saveName) {
        alert('Invalid character name. HTML and script content is not allowed.');
        return 'Invalid Name';
    }

    // SHORTCUTS for our favorite characters

    if (saveName === 'Lanora') { saveName = 'Lanora Snugglebottom'; } 
    if (saveName === 'Yarg') { saveName = 'Yarg Smashskull'; } 
    if (saveName === 'Gerald') { saveName = 'Gerald the Bold'; }
    if (saveName === 'Sylonnus') { saveName = 'Sylonnus Transvexus'; }

    postData.name = saveName; // add the name to the postData
    console.log('SAVE_CHAR Post Data', postData)
    const API_URL = charsheetAPI + '?TableName=' + charsheetTable + '&campaign=' + campaign + '&name=' + saveName;

    let res = { data: {} };
    try {
        res = await axios({
            host: charsheetAPI,
            method: 'PUT',
            url: API_URL,
            headers: { 'content-type': 'text/plain' },
            withCredentials: true,
            data: { version: version, chardata: postData },   // this is the 'body' in AWS
        });

        console.log('SAVE_CHAR response:', res.data);

        if ( res.data.askUserAboutNew ) {
            const decision = window.confirm("This character is new. OK to save?");
            if (!decision) {
                console.log('User cancelled character save.');
                return;
            }
            else {
                res = await axios({
                    host: charsheetAPI,
                    method: 'PUT',
                    url: API_URL + '&addNewConfirmed=true',
                    headers: { 'content-type': 'text/plain' },
                    withCredentials: true,
                    data: { version: version, chardata: postData },   // this is the 'body' in AWS
                });

            }
        }
            
        console.log('character saved:', res);
        
    } catch (error) {
        // console.error('Error saving character:', error);
        if (error.response) {
            alert(error.response.data);
            if (error.response.data === "insufficient user permissions") {
                alert('Access denied. Probably not your character.\n\nTry saving as a different name.');
            }
        }
        console.error('Error saving character:', error.response ? error.response : error.message);
        res.data = error;
    }

    // error checking needed here !!  
    
    if (setChar !== '') {
        setChar(saveName);
    }

    return res.data;
}

export default SAVE_CHAR